﻿const guideInitialState = {
    formData: {
        step1: {
            age: null
        },
        step2: {
            occupation: null
        },
        step3: {
            maritalStatus: null
        },
        step4: {
            hasChildren: null,
            willHaveChildren: null
        },
        step5: {
            livingSituation: null
        },
        step6: {
            hasVacationHome: null
        },
        step7: {
            interests: []
        },
        step8: {
            pets: []
        }
    }
};

export function insuranceGuideFormData(state = guideInitialState, action) {
    switch (action.type) {
        case 'INSURANCE_GUIDE_UPDATE_FORM_DATA':
            return { formData: {...state.formData, ...action.formData } };
        default:
            return state;
    }
}